// extracted by mini-css-extract-plugin
export default {"shimmer":"CopyBtn_shimmer__P3KLH","dark_shimmer":"CopyBtn_dark_shimmer__y7f3p","copy_btn":"CopyBtn_copy_btn__vAeBU"};